module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-mobile-english.e18cb00b.jpg";